import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeviceThermostatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"device_thermostat"}/>
}
